<app-contact-documents [contact]="contact"></app-contact-documents>
<app-contact-logo-treatment [contact]="contact"></app-contact-logo-treatment>
<app-contact-editor [contact]="contact"></app-contact-editor>